module.exports = __webpack_public_path__ + "static/img/20a.4c91409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20a.jpg
// module id = Wt1k
// module chunks = 0